import { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Divider, typographyVariants } from '@mint-lib/tw-components';

import { getMapLabelByOperationType } from '../constants/shared.js';
import type { OperationTypes } from '../constants/shared.js';

type Props = {
  variant: OperationTypes;
};

const Separator: FC<Props> = ({ variant }) => {
  const { t } = useTranslation('@mint-lib/approval-flow-circuit_v2');
  const mapLabelByOperationType = getMapLabelByOperationType(t);
  const separatorLabel = mapLabelByOperationType[variant].toUpperCase();

  return (
    <div className="flex items-center gap-2">
      <div className="grow">
        <Divider orientation="horizontal" />
      </div>
      <span
        className={typographyVariants({
          variant: 'bodyShort01',
          color: 'secondary',
          className: 'shrink-0',
        })}
      >
        {separatorLabel}
      </span>
      <div className="grow">
        <Divider orientation="horizontal" />
      </div>
    </div>
  );
};

export default Separator;
